import { API_HOST_ORGS, API_HOST_SEARCH, API_HOST_REPORTS } from "../config";
import { AwardingOrgSearchService } from "./AwardingOrgSearchService";
import { AwardingOrgService } from "./AwardingOrgService";
import { ReportsService } from "./ReportsService";

export const aoService = new AwardingOrgService(API_HOST_ORGS);
export const aoServiceSearch = new AwardingOrgSearchService(API_HOST_SEARCH);

export const reportsService = new ReportsService(API_HOST_REPORTS)